import { lang } from '@ott/l10n';

let hostname = '';

if (__DEV__) {
  hostname = 'https://www.solartrip.com';
}

export const REGIONS = {
  ASIA: 'asia',
  EUROPE: 'europe',
  AFRICA: 'africa',
  OCEANIA: 'oceania',
  NORTH_AMERICA: 'northAmerica',
  SOUTH_AMERICA: 'southAmerica',
};

export const REGIONS_DICT_KEYS = {
  [REGIONS.ASIA]: 'Asia',
  [REGIONS.EUROPE]: 'Europe',
  [REGIONS.AFRICA]: 'Africa',
  [REGIONS.OCEANIA]: 'Oceania',
  [REGIONS.NORTH_AMERICA]: 'North_America',
  [REGIONS.SOUTH_AMERICA]: 'South_America',
};

export const NOT_EXIST_COUNTRIES = [
  'SJ',
  'CC',
  'MV',
  'CX',
  'YT',
  'RE',
  'TK',
  'AN',
  'BQ',
  'GP',
  'MQ',
  'GF',
];

export const GOOGLE_MAPS_KEY = 'AIzaSyD9HVlff1Zy-3rhRmIKttf82W2ks5PkPu4';

// TODO: Rename this to UPPER_SNAKE_CASE
export const urls = {
  mobile: {
    profile: `//solartrip.com/${lang}/p/`,
    ticket: `//solartrip.com/${lang}/ticket/`,
    auth: `//solartrip.com/${lang}/auth/`,
    achievements: `//solartrip.com/${lang}/loyalty/achievements/`,
    travelexpert: `//solartrip.com/${lang}/loyalty/travelexpert/`,
  },

  flightsSearch: `${hostname}/${lang}/f/#/search`,
  toursSearch: `${hostname}/${lang}/tours/search`,
  busSearch: `${hostname}/${lang}/bus`,
  hotelsSearch: `${hostname}/${lang}/hotels`,
};
export const cookiePolicyCookieName = 'cookiePolicyHasAccepted';
export const noopHref = 'javascript:void(0)';
export const appIds = {
  fb: '508221522974992',
};

export const keyCodes = {
  RIGHT_ARROW: 39,
  LEFT_ARROW: 37,
  ESC: 27,
};

export const USER_STATUSES = {
  guest: 'guest',
  classic: 'classic',
  pro: 'pro',
  premium: 'premium',
};

export const DESKTOP_MIN_WIDTH = 768;
export const MOBILE_MAX_WIDTH = 767;

export const gaConfig = {
  nonInteraction: {
    nonInteraction: true,
  },
  VIEW_APP_TARGET: 'ott://solartrip.com',
};

export const DEFAULT_VIEW_LOCALES = [
  'ru',
  'ru-ua',
  'uk-ua',
  'ru-kz',
  'ru-by',
  'en-gb',
  'en-ie',
  'en-us',
  'en-ae',
  'es',
  'de',
  'pl',
  'tr',
];

export const DEFAULT_RESELLERS = {
  ru: '12trip.ru',
  'ru-ua': '12trip_ru-ua',
  'uk-ua': '12trip.ua',
  'ru-kz': '12trip.kz',
  'ru-by': '12trip_ru-by',
  'en-gb': '12trip.co.uk',
  'en-ie': '12trip.ie',
  'en-us': '12trip.us',
  es: '12trip.es',
  de: '12trip.de',
  pl: '12trip.pl',
  tr: '12trip.tr',
};

export const VIEW_APP_PARAMS = ['view', 'ottApiVersion', 'deeplinkScheme'];

export const VIEW_APP_UPDATE_TYPE = {
  UPDATE_LINK: 'updateLink',
  UPDATE_DEEPLINK: 'updateDeeplink',
  REPLACE_APPLINK: 'replaceApplink',
};

export const COOKIE_POLICY_LINK = `https://support.solartrip.com/hc/${lang}/articles/4789512322717-Cookies-Policy`;
